"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackEvent = TrackEvent;
exports.TrackCookieFreeEvent = TrackCookieFreeEvent;
exports.IdentifyUserInAnalytics = IdentifyUserInAnalytics;
exports.SetUserTraits = SetUserTraits;
const platform_1 = __importDefault(require("platform"));
const index_1 = require("../index");
const RudderStackAnalyticsMapper_1 = require("./RudderStackAnalyticsMapper");
const RudderStackService_1 = require("./RudderStackService");
const RudderStackService_2 = require("./RudderStackService");
// Setting the IP address here, overwrites the property, so the real value doesn't get stored in RudderStack.
const options = { ip: "0.0.0.0" };
function TrackEvent(eventName, customProperties) {
    var _a;
    const service = (0, RudderStackService_1.rudderStackService)();
    if (typeof window === "undefined" ||
        service === null ||
        service.isInitialized() == false) {
        return;
    }
    const rudderAnalytics = service.rudderAnalytics;
    try {
        const mappedProperties = (0, RudderStackAnalyticsMapper_1.MapAnalyticsProperties)(customProperties);
        // Clone object so we can delete currentUserId without messing up other tracking
        const properties = RemoveUnsetProperties(Object.assign(Object.assign({}, mappedProperties), { clientOS: (_a = platform_1.default.os) === null || _a === void 0 ? void 0 : _a.toString(), clientDevice: platform_1.default.product }));
        IdentifyUserInAnalytics(properties.userId);
        rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.track(eventName, properties, options);
    }
    catch (e) {
        index_1.Log.error("Unexpected error tracking event in RudderStack", {
            originalException: e,
            tags: {
                logger: "TrackEvent",
            },
        });
    }
}
// All events tracked in the Patient Portal should use TrackCookieFreeEvent
function TrackCookieFreeEvent(eventName, customProperties) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const service = (0, RudderStackService_2.rudderStackCookieFreeService)();
        if (typeof window === "undefined" || service === null) {
            return {
                success: false,
                error: "No window or Rudderstack service",
            };
        }
        try {
            const mappedProperties = (0, RudderStackAnalyticsMapper_1.MapAnalyticsProperties)(customProperties);
            // Clone object so we can delete currentUserId without messing up other tracking
            const properties = RemoveUnsetProperties(Object.assign(Object.assign({}, mappedProperties), { clientOS: (_a = platform_1.default.os) === null || _a === void 0 ? void 0 : _a.toString(), clientDevice: platform_1.default.product }));
            // Stripping out urlId for RudderStack events (PII)
            delete properties.urlId;
            const { response, error } = yield (service === null || service === void 0 ? void 0 : service.track(eventName, properties));
            if (response && response.ok) {
                return {
                    success: true,
                    error: null,
                };
            }
            const errorMessage = `Tracking call failed in RudderStack${response && response.status
                ? ` with status ${response.status}:`
                : ":"} ${error}`;
            index_1.Log.error(errorMessage, {
                tags: {
                    logger: "TrackCookieFreeEvent",
                    eventName,
                    responseStatus: (_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : "unknown",
                },
                context: [
                    {
                        name: "Response details",
                        data: {
                            status: (_c = response === null || response === void 0 ? void 0 : response.status) !== null && _c !== void 0 ? _c : "unknown",
                            body: (_e = (_d = response === null || response === void 0 ? void 0 : response.body) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : "unknown",
                        },
                    },
                ],
            });
            return {
                success: false,
                error: errorMessage,
            };
        }
        catch (e) {
            // We want to ignore those specific errors. They are mainling comming for some blocking request (ie: Tracking/Ads blocker)
            // To replicate this issue, block rudderstack domain in your devtool
            // NB: All of the listed error are the same error, just different error message depending on the browser
            // https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios
            const ignoreLogsErrors = e instanceof Error &&
                e.name === "TypeError" &&
                [
                    "Failed to fetch",
                    "Load failed",
                    "cancelled",
                    "NetworkError when attempting to fetch resource.",
                ].includes(e.message);
            if (!ignoreLogsErrors) {
                index_1.Log.error("Unexpected error tracking event in RudderStack (Cookie Free)", {
                    originalException: e,
                    tags: {
                        eventName,
                        logger: "TrackCookieFreeEvent",
                    },
                });
            }
            return {
                success: false,
                error: `Tracking call failed: ${e}`,
            };
        }
    });
}
// Converts AnalyticsProperties to apiObject so we can safely use in tracking.
// Null and undefined properties are removed because not supported by RudderStack.
function RemoveUnsetProperties(customProperties) {
    const properties = {};
    for (const key in customProperties) {
        const value = customProperties[key];
        if (typeof value === "string" ||
            typeof value === "number" ||
            typeof value === "boolean") {
            properties[key] = value;
        }
        else if (Array.isArray(value)) {
            properties[key] = RemoveUnsetPropertiesForArray(value);
        }
        else if (value !== null && value !== undefined) {
            properties[key] = RemoveUnsetProperties(value);
        }
    }
    return properties;
}
function RemoveUnsetPropertiesForArray(customProperties) {
    return customProperties.map((x) => {
        if (typeof x === "string" ||
            typeof x === "number" ||
            typeof x === "boolean") {
            return x;
        }
        else {
            return RemoveUnsetProperties(x);
        }
    });
}
let cookieSet = false;
function IdentifyUserInAnalytics(userId) {
    try {
        const service = (0, RudderStackService_1.rudderStackService)();
        if (typeof window === "undefined" ||
            service === null ||
            service.isInitialized() == false) {
            return;
        }
        const rudderAnalytics = service.rudderAnalytics;
        const currentUserId = rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.getUserId();
        if (currentUserId !== userId) {
            if (currentUserId) {
                // Pass true so that anonymousId is reset, otherwise if multiple users use the same browser they may get merged into 1 user
                rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.reset(true);
                UpdateAnonymousIdCookie(rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.getAnonymousId());
            }
            if (userId) {
                rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.identify(userId, {}, options);
            }
        }
        // Set cookie once on load, in-case it has never been set
        if (!cookieSet) {
            UpdateAnonymousIdCookie(rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.getAnonymousId());
        }
    }
    catch (e) {
        index_1.Log.error("Unexpected error identifying user in RudderStack", {
            originalException: e,
        });
    }
}
function SetUserTraits(userTraits) {
    const service = (0, RudderStackService_1.rudderStackService)();
    if (typeof window === "undefined" ||
        service === null ||
        service.isInitialized() == false) {
        return;
    }
    const rudderAnalytics = service.rudderAnalytics;
    rudderAnalytics === null || rudderAnalytics === void 0 ? void 0 : rudderAnalytics.identify(userTraits);
}
// Sets the anonymous id on a cookie, so it can be picked up server-side for tracking pre-login events e.g. login failure
function UpdateAnonymousIdCookie(anonymousId) {
    document.cookie = `analytics-anonymous-id=${anonymousId}; path=/; domain=${getCookieDomain()}`;
    cookieSet = true;
}
// Gets domain to allow anonymous-id cookie on.
// Aim is to allow anonymous-id cookie across subdomains e.g. from web.accurx.com to chain.accurx.com
// If accurx.thirdparty.nhs.uk, we don't want to allow the cookie across nhs.uk, but any subdomains of accurx.thirdparty.nhs.uk are ok.
function getCookieDomain() {
    const hostname = window.location.hostname;
    const topDomains = [
        "accurx.thirdparty.nhs.uk",
        "accurx.nhs.uk",
        "dev.accurx.com",
        "accurx.com",
    ];
    for (const i in topDomains) {
        const topDomain = topDomains[i];
        if (hostname.endsWith(`.${topDomain}`) || hostname === topDomain) {
            return topDomain;
        }
    }
    return "";
}
//# sourceMappingURL=RudderStackAnalyticsTracker.js.map